module.exports = __webpack_public_path__ + "static/img/guide-pdf-upload.fdf5f2b2.svg";